import { render, staticRenderFns } from "./DeleteCache.vue?vue&type=template&id=987d0846"
import script from "./DeleteCache.vue?vue&type=script&lang=js"
export * from "./DeleteCache.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports